import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { 
  listCategories, 
  createCategory, 
  updateCategory, 
  updateCategoryStatus 
} from '../../api/helpCenterCategory';
import { message } from 'antd';

// 查询帮助中心分类列表
export const fetchHelpCenterCategories = createAsyncThunk(
  'helpCenterCategory/fetchList',
  async (params = { page: 1, pageSize: 10 }, { rejectWithValue }) => {
    try {
      const response = await listCategories(params);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '获取列表失败';
      message.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

// 创建帮助中心分类
export const createHelpCenterCategory = createAsyncThunk(
  'helpCenterCategory/create',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await createCategory(data);
      message.success('创建成功');
      // 创建成功后重新获取列表
      dispatch(fetchHelpCenterCategories());
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '创建失败';
      message.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

// 更新帮助中心分类
export const updateHelpCenterCategory = createAsyncThunk(
  'helpCenterCategory/update',
  async ({ id, data }, { rejectWithValue, dispatch }) => {
    try {
      const response = await updateCategory(id, data);
      message.success('更新成功');
      // 更新成功后重新获取列表
      dispatch(fetchHelpCenterCategories());
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '更新失败';
      message.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

// 更新帮助中心分类状态
export const updateHelpCenterCategoryStatus = createAsyncThunk(
  'helpCenterCategory/updateStatus',
  async ({ id, status }, { rejectWithValue, dispatch }) => {
    try {
      const response = await updateCategoryStatus(id, status);
      message.success('状态更新成功');
      // 更新成功后重新获取列表
      dispatch(fetchHelpCenterCategories());
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '状态更新失败';
      message.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

const helpCenterCategorySlice = createSlice({
  name: 'helpCenterCategory',
  initialState: {
    categories: [],
    total: 0,
    currentPage: 1,
    pageSize: 10,
    loading: false,
    currentCategory: null,
    error: null
  },
  reducers: {
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setCurrentCategory: (state, action) => {
      state.currentCategory = action.payload;
    }
  },
  extraReducers: (builder) => {
    // 查询列表
    builder.addCase(fetchHelpCenterCategories.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchHelpCenterCategories.fulfilled, (state, action) => {
      state.loading = false;
      state.categories = action.payload.records || [];
      state.total = action.payload.total || 0;
    });
    builder.addCase(fetchHelpCenterCategories.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // 创建
    builder.addCase(createHelpCenterCategory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createHelpCenterCategory.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createHelpCenterCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // 更新
    builder.addCase(updateHelpCenterCategory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateHelpCenterCategory.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateHelpCenterCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // 更新状态
    builder.addCase(updateHelpCenterCategoryStatus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateHelpCenterCategoryStatus.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateHelpCenterCategoryStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

export const { setPage, setPageSize, setCurrentCategory } = helpCenterCategorySlice.actions;
export default helpCenterCategorySlice.reducer;

